import { Box } from "@mui/material";

import { BasicPostCardProps } from "../../../../../types/components/props.type";
import { usePostFormatter } from "../../../../../hooks/usePostFormatter";

import PostMedia from "../PostMedia";
import PostDescriptionAndDetails from "./PostDescriptionAndDetails";
import PostCard from "../../..";

const BasicPostCard = ({ post, onClickOnMedia }: BasicPostCardProps) => {
  const { description, tags, sharedPost } = post;
  const { postMedia } = usePostFormatter(post);

  const handleMediaClick = () => onClickOnMedia(post);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <PostDescriptionAndDetails description={description} tags={tags} />
      <Box sx={{ padding: "0 16px" }}>
        {sharedPost && (
          <PostCard post={sharedPost} onClickOnMedia={() => onClickOnMedia(sharedPost)} isSharedPost={true} />
        )}
      </Box>
      <PostMedia media={postMedia} onClickOnMedia={handleMediaClick} />
    </Box>
  );
};

export default BasicPostCard;
